import { Constants } from '.'

export const openModal = payload => ({
  type: Constants.UI_MODAL_OPEN,
  payload
})

export const closeModal = () => ({
  type: Constants.UI_MODAL_CLOSE
})

export const clearModalProps = () => ({
  type: Constants.UI_MODAL_CLEAR_PROPS
})
